<template>
  <div class="animated fadeIn form-abm">
    <b-card no-header>
      <b-form>
        <app-cliente
          label="Cliente"
          :nombre="clienteNombre"
          :labelCols="labelCols"
          :lista="clientesList"
          @updated="clienteActualizado">
        </app-cliente>  

        <b-form-group
          label="Evento"
          label-for="evento"
          :label-cols="labelCols"
          horizontal>
          <b-input-group>
            <b-input-group-append 
                class="filter-search-icons" 
                @click="seleccionarEvento">
              <b-input-group-text>
                <i class="fa fa-search"></i>
              </b-input-group-text>
            </b-input-group-append>
            <b-form-input 
              id="evento"
              :value="eventoNombre"
              readonly
              type="text"/>
          </b-input-group>
        </b-form-group>

        <app-evento-etapa
          label="Etapa"
          :nombre="eventoEtapaNombre"
          labelOption="Todas las etapas"
          :labelCols="labelCols"
          :lista="eventosEtapasList"
          :readOnly="!existsEventosEtapas"
          @updated="eventoEtapaActualizado">
        </app-evento-etapa> 

        <b-form-group
          label="Fecha Desde"
          label-for="fechaDesde"
          :label-cols="labelCols"
          description="Solicitudes de transferencias emitidas desde esta fecha"
          horizontal>
          <b-form-input 
            id="fechaDesde" 
            v-model="fechaDesde" 
            type="date">
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Fecha Hasta"
          label-for="fechaHasta"
          :label-cols="labelCols"
          description="Solicitudes de transferencias emitidas hasta esta fecha"
          horizontal>
          <b-form-input 
            id="fechaHasta" 
            v-model="fechaHasta" 
            type="date">
          </b-form-input>
        </b-form-group>
      </b-form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="preview">Preview</b-button>
        <b-button size="sm" variant="primary" class="footer-button" 
          @click.prevent="close">Cancelar</b-button>
      </div>
    </b-card>

    <b-modal ref="searchEventoModal" 
        title="Seleccionar Evento"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-evento
        :clienteId="clienteId"
        @eventoSeleccionado="eventoSeleccionado">
      </app-search-evento>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Cliente from '../shared/abmSelect.vue';
import SearchEvento from '../eventos/SearchList';
import EventoEtapa from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import exportXLS from '../../mixins/export_xls_export_transferencias';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'exportTransferencias/getField',
  mutationType: 'exportTransferencias/updateField',
});

export default {
  name: 'ExportTransferenciasABM',
  components: {
    appCliente: Cliente,
    appSearchEvento: SearchEvento,
    appEventoEtapa: EventoEtapa,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal,
    exportXLS
  ],
  data () {
    return {
      clientes: [],
      clientesList: [],

      labelCols: 2,
      loadingClientes: false
    }
  },
  computed: {
    ...mapFields([
      'clienteId',
      'cliente',
      'clienteNombre',
      'evento',
      'eventoNombre',
      'fechaDesde',
      'fechaHasta',
      'eventoEtapa',
      'eventoEtapaNombre',

      'eventosEtapas',
      'eventosEtapasList'
    ]),
    existsEventosEtapas() {
      if (this.eventosEtapasList) {
        return this.eventosEtapasList.length != 0;
      }

      return false;
    }
  },  
  created() {
    // let sorteoGlobalId = 0;
    // if (this.$route.params){
    //   if (this.$route.params.id){
    //     sorteoGlobalId = this.$route.params.id;
    //   }
    // }
    let exportId = 0;

    this.showSpinner();
    this.loadingClientes = true;
    this.$store.dispatch('exportTransferencias/inicializar', exportId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      this.$store.dispatch('clientes/getList')
        .then(() => {
          this.clientes = this.$store.getters['clientes/list']
          this.clientesList = this.$store.getters['clientes/selectList']
          this.loadingClientes = false;
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de clientes')))
    },
    seleccionarEvento() {
      if (this.clienteId != 0) {
        this.$refs.searchEventoModal.show();
      } else {
        this.showErrorMsj(new Error('Debe seleccionar el cliente en primer término'))
      }
    },
    eventoSeleccionado(evento) {
      this.$refs.searchEventoModal.hide();
      if (evento) {
        this.showSpinner();
        this.$store.dispatch('exportTransferencias/setEvento', evento)
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    save () {
      let save = true;

      if (save) {
        this.showSpinner();
        this.$store.dispatch('exportTransferencias/save')
          .then(()  => this.showModalMsj('El export se registró con éxito.', this.closeEmitido, this.closeEmitido, 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner())
      } 
    },
    preview () {
      let save = true;

      if (save) {
        let exportTransferencias = [];
        this.showSpinner();
        this.$store.dispatch('exportTransferencias/preview')
          .then(()  => {
            exportTransferencias = this.$store.getters['exportTransferencias/exportTransferenciasRpt'];
            
            return this.$store.dispatch('eventoDatos/getDatos', this.evento.id);
          })
          .then(() => {
            let evento = this.$store.getters['eventoDatos/evento'];

            this.exportXLSExportTransferenciasPreview(evento, exportTransferencias, 'export_transferencias_preview');
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner())
      } 
    },
    closeEmitido() {
      this.$emit('close', true)    
    },
    close() {
      this.$emit('close', false)    
    },
    clienteActualizado(clienteNombre) {
      if (!this.loadingClientes) {
        this.clienteNombre = clienteNombre;

        let cliente;
        if (clienteNombre) {
          cliente = this.getSelected(this.clientes, clienteNombre);
        }
        this.$store.dispatch('exportTransferencias/setCliente', cliente);

        this.clienteValido = null;
        this.clienteInvalidoMsj = '';
      }
    },
    eventoEtapaActualizado(eventoEtapaNombre) {
      let eventoEtapa;
      if (eventoEtapaNombre) {
        eventoEtapa = this.getSelected(this.eventosEtapas, eventoEtapaNombre);
      }
      this.$store.dispatch('exportTransferencias/setEventoEtapa', eventoEtapa);
    },
  },
  watch: {
  },
}
</script>

<style>
</style>
